// App-specific categories. These do not exist in the BE data models.
export const BRANCHES = 'BRANCHES';
export const DATA_OPS = 'DATA_OPS';
export const DELAY = 'DELAY';
export const LOOPS = 'LOOPS';
export const QUICK_ACTIONS = 'QUICK_ACTIONS';
export const SALESFORCE = 'SALESFORCE';
export const SLACK = 'SLACK';
export const UNCATEGORIZED = 'UNCATEGORIZED';
export const WORKFLOW = 'WORKFLOW';

/**
 * From ListingCategory:
 * https://git.hubteam.com/HubSpot/AutomationActions/blob/d6b40b59/AutomationActionsCore/src/main/java/com/hubspot/automation/actions/core/definition/hubspot/ListingCategory.java
 */
export const AI_SKILLS = 'AI_SKILLS';
export const COMMUNICATIONS = 'COMMUNICATIONS';
export const CRM = 'CRM';
export const MARKETING = 'MARKETING';
export const PROPERTY_MANAGEMENT = 'PROPERTY_MANAGEMENT';
/**
 * @deprecated Use MARKETING instead
 */
export const AD_MANAGEMENT = 'AD_MANAGEMENT';
/**
 * @deprecated Use CRM instead
 */
export const ASSIGNMENT = 'ASSIGNMENT';
/**
 * @deprecated Use CRM instead
 */
export const CREATE_OBJECT = 'CREATE_OBJECT';
/**
 * @deprecated Use COMMUNICATIONS instead
 */
export const EXTERNAL_COMMUNICATION = 'EXTERNAL_COMMUNICATION';
/**
 * @deprecated Use COMMUNICATIONS instead
 */
export const INTERNAL_COMMUNICATION = 'INTERNAL_COMMUNICATION';
/**
 * @deprecated Use MARKETING instead
 */
export const LIST_MANAGEMENT = 'LIST_MANAGEMENT';

/**
 * NOTE(bheng): The original comment where this map was copied from was from
 * 2023. We we want to revisit this mapping, but it seems safe to keep around.
 */
export const RedesignedActionCategoryMap = {
  AD_MANAGEMENT: MARKETING,
  AI_SKILLS,
  ASSIGNMENT: CRM,
  COMMUNICATIONS,
  CREATE_OBJECT: CRM,
  CRM,
  EXTERNAL_COMMUNICATION: COMMUNICATIONS,
  INTERNAL_COMMUNICATION: COMMUNICATIONS,
  LIST_MANAGEMENT: MARKETING,
  MARKETING,
  PROPERTY_MANAGEMENT: CRM,
  TESTING: undefined
};